import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import {
  FETCH_SWITCHORGANIZATIONS_REQUEST,
  FETCH_SWITCHORGANIZATIONS_SUCCESS,
  FETCH_SWITCHORGANIZATIONS_FAILURE,
  fetchSwitchOrganizationsFailure,
  fetchSwitchOrganizationsSuccess,
} from '../actions/switchOrganizationAction';
import { getBaseUrl } from '../utils/getBaseUrl';

const getAuthToken = () => localStorage.getItem('authToken');

function* fetchSwitchOrganizationSaga(action) {
  try {
    console.log("Action payload:", action.payload);
    const { orgId } = action.payload;
    const token = localStorage.getItem('authToken');
    console.log("Current token:", token);
    const response = yield call(axios.post, `${getBaseUrl()}/api/auth/switch-organization/${orgId}`, {}, {
      headers: { Authorization: `Bearer ${token}` },
    });
    console.log("API response:", response.data);
    const accessToken = response.data;
    if (!accessToken) {
      throw new Error("No access token returned from the API.");
    }
    localStorage.setItem('authToken', accessToken);
    window.location.reload();
    yield put(fetchSwitchOrganizationsSuccess(accessToken));
  } catch (error) {
    console.error("Error in saga:", error);
    yield put(fetchSwitchOrganizationsFailure(error.message));
  }
}

export default function* switchOrganizationSaga() {
  yield takeLatest(FETCH_SWITCHORGANIZATIONS_REQUEST, fetchSwitchOrganizationSaga);
}
